import { useGameTags } from '@/api/game-tags';
import { Section } from '@starsoft/common/components';
import { GameTag } from '@/models/game/tag';
import GameTagCard from './Card';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

export default function GameTagsList() {
  const { push } = useRouter();
  const {
    gameTags,
    error,
    isLoading,
    refetch,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    metadata,
  } = useGameTags();

  const onTagClick = useCallback(
    (tag: GameTag) => {
      push(`/games/tag/${tag?.slug}`);
    },
    [push],
  );

  return (
    <Section
      data={gameTags as GameTag[]}
      limit={20}
      paginated
      paginationType="manual"
      error={error}
      hasMore={hasNextPage}
      isLoading={isLoading}
      isLoadingMore={isFetchingNextPage}
      loadMore={fetchNextPage}
      refetch={refetch}
      totalCount={metadata?.count}
      componenents={{
        component: tag => (
          <GameTagCard
            gameTag={tag}
            onClick={onTagClick}
            key={`game-tag-section-${tag}-${tag?.id}`}
          />
        ),
        skeleton: index => (
          <GameTagCard
            gameTag={{} as GameTag}
            key={`game-tag-section-skeleton-${index}`}
            isLoading
          />
        ),
      }}
    />
  );
}
